/** @format */

import { createContext } from 'react';
export const ClientContext = createContext();
